// src/features/data-dashboard/dataDashboardSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    activeStep: 0,
    uploadedFiles: [],
    uploadedFileRes: [],
    uploadedUrls: [],
    imageUrls: [],
    loading: false,
    dashboardReport: null,
    analysisLoading: false,
    analysisDone: false,
    finalReportUrl: null,
    uiStep: 1,
    dashboardExcelSheets: {},
    dashboardSelectedSheets: {},
    view: "library",
    uploadedData: null,
    selectedType: "",
    selectedSheets: [],
    recommendedType: "",
    dashboardData: null,
    hasLibraryData: true,
};

export const dataDashboardSlice = createSlice({
    name: "dataDashboard",
    initialState,
    reducers: {
        setUiStep: (state, action) => {
            state.uiStep = action.payload;
        },
        resetUiStep: (state) => {
            state.uiStep = 1;
        },
        setActiveStep: (state, action) => {
            state.activeStep = action.payload;
        },
        nextStep: (state) => {
            state.activeStep += 1;
        },
        previousStep: (state) => {
            state.activeStep -= 1;
        },
        resetStep: (state) => {
            state.activeStep = 0;
        },
        setImageUrls: (state, action) => {
            state.imageUrls = action.payload;
        },
        resetImageUrls: (state) => {
            state.imageUrls = [];
        },
        addUploadedFiles: (state, action) => {
            state.uploadedFiles = [
                ...state.uploadedFiles,
                ...action.payload.map((file) => ({
                    name: file.name,
                    size: file.size,
                    type: file.type,
                })),
            ];
        },
        addUploadedFileRes: (state, action) => {
            state.uploadedFileRes = [...state.uploadedFileRes, ...action.payload];
        },
        removeUploadedFile: (state, action) => {
            const index = action.payload;
            const fileToRemove = state.uploadedFiles[index];
            state.uploadedFiles = state.uploadedFiles.filter((_, i) => i !== index);
            state.uploadedUrls = state.uploadedUrls.filter((_, i) => i !== index);
            state.uploadedFileRes = state.uploadedFileRes.filter(
                (res) => !res.includes(fileToRemove.name)
            );
        },
        clearDashboardData: (state) => {
            state.uploadedFiles = [];
            state.uploadedFileRes = [];
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setDashboardReport: (state, action) => {
            state.dashboardReport = action.payload;
        },
        clearDashboardReport: (state) => {
            state.dashboardReport = initialState.dashboardReport;
        },
        setAnalysisLoading: (state, action) => {
            state.analysisLoading = action.payload;
        },
        setAnalysisDone: (state, action) => {
            state.analysisDone = action.payload;
        },
        setFinalReportUrl: (state, action) => {
            state.finalReportUrl = action.payload;
        },
        setUploadedUrls: (state, action) => {
            state.uploadedUrls = [...state.uploadedUrls, ...action.payload];
        },
        addUploadedUrl: (state, action) => {
            state.uploadedUrls.push(action.payload);
        },
        setDashboardExcelSheets: (state, action) => {
            state.dashboardExcelSheets = { ...state.dashboardExcelSheets, ...action.payload };
        },
        setDashboardSelectedSheets: (state, action) => {
            state.dashboardSelectedSheets = action.payload;
        },
        resetDashboard: (state) => {
            return { ...initialState };
        },
        setView: (state, action) => { state.view = action.payload; },
        setUploadedData: (state, action) => { state.uploadedData = action.payload; },
        setSelectedType: (state, action) => { state.selectedType = action.payload; },
        setSelectedSheets: (state, action) => { state.selectedSheets = action.payload; },
        setRecommendedType: (state, action) => { state.recommendedType = action.payload; },
        setDashboardData: (state, action) => { state.dashboardData = action.payload; },
        setHasLibraryData: (state, action) => { state.hasLibraryData = action.payload; },
    },
});

export const {
    setActiveStep,
    nextStep,
    previousStep,
    resetStep,
    addUploadedFiles,
    addUploadedFileRes,
    removeUploadedFile,
    clearDashboardData,
    setLoading,
    setDashboardReport,
    clearDashboardReport,
    resetDashboard,
    setAnalysisLoading,
    setAnalysisDone,
    setUiStep,
    resetUiStep,
    setUploadedUrls,
    addUploadedUrl,
    resetUploadedUrls,
    setFinalReportUrl,
    setImageUrls,
    setDashboardExcelSheets,
    setDashboardSelectedSheets,
    setView,
    setUploadedData,
    setSelectedType,
    setSelectedSheets,
    setRecommendedType,
    setDashboardData,
    setHasLibraryData,
} = dataDashboardSlice.actions;

export default dataDashboardSlice.reducer;
